import {Component, OnDestroy, OnInit}   from '@angular/core';
import {ActivatedRoute, Router}         from "@angular/router";

import {Query}                          from "../../services/query/query";
import {UserService}                    from "../../services/user/user.service";

import {Subscription}                   from "rxjs/Subscription";
import {environment} from "../../../environments/environment";


@Component({
  selector: 'app-login-admin',
  templateUrl: './login-admin.component.html',
  styleUrls: ['./login-admin.component.css']
})


/**
 * Handle the login screen work.
 */
export class LoginAdminComponent implements OnInit, OnDestroy {

	loginSubscription:Subscription;
	model: any = {};
	version: string = environment.version;


	/**
	 * Initialize everything.
	 *
	 * @param {ActivatedRoute} route
	 * @param {Router} router
	 * @param {UserService} userService
	 */
	constructor(

		private route: ActivatedRoute,
        private router: Router,
        private userService: UserService

	) {}


	/**
	 * Always clear any existing session data before starting.
	 */
	ngOnInit() {

		sessionStorage.clear();

	}


	/**
	 * Unsubscribe from any subscriptions to avoid memory leaks.
	 */
	ngOnDestroy() {

		if (this.loginSubscription) {
			this.loginSubscription.unsubscribe();
		}

	}


	/**
	 * Log in the user and route them to the list articles page,
	 * or display an error message if there's an error.
	 */
	login() {

		this.loginSubscription = this.userService.login(this.model.uname, this.model.password)
			.subscribe(
				() => {

					this.router.navigate(['/articles/list']);

				},
				(error) => {

					if (Query.isUnauthorizedAccessError(error)) {

						window.alert('Invalid user name or password');

					} else {

						window.alert('Unknown server error occurred. Notify the system administrator.');

					}

				}

			);

	}

}



// WEBPACK FOOTER //
// ./src/app/admin/login/login-admin.component.ts